<template>
    <div class="eqs-zipcode" :el-class="elClass">
        <EqsText v-bind="$attrs" :basic-rules="$options.rules" v-on="$listeners" />
    </div>
</template>

<script>
import { cssTypes, dataTypes } from "./EqsZipcode.js";
import { eqsUITemplate } from "../../../mixins/styleMixin";
import { zipcodeR } from "../../../rules";

export default {
    name: "EqsZipcode",
    components: {
        EqsText: () => import("../EqsText/EqsText.vue")
    },
    mixins: [eqsUITemplate],
    rules: [zipcodeR],
    props: {
        elClass: {
            type: String,
            default: "eqs-zipcode"
        }
    },
    data() {
        return {
            cssTypes,
            dataTypes
        };
    }
};
</script>

<style lang="scss">
@import "../../../../../shared/styles/components/atoms/EqsZipcode.scss";
</style>
